module.exports = __webpack_public_path__ + "img/MiCONNECT_CMYK.1b8d3425.svg";